/**
 * DISCLAIMER: This file has been migrated from js file
 * Therefore there are so many 'any' types.
 * Please feel free to refactor it.
 */
import { IOption } from '../../../components/form/fields/MultiChoice/interfaces';

const MAX_LEVEL = 7;

export const buildItems = (items: any, parentId: string | null, level = 0) =>
  items
    .filter((item: any) => parentId === item.parentId)
    .map((item: any) => ({
      ...item,
      children: level > MAX_LEVEL ? [] : buildItems(items, item.id, level + 1),
    }));

export const buildTree = (oldItems: any) => {
  const items = JSON.parse(JSON.stringify(oldItems));

  return buildItems(items, null);
};

export const prepareOptions = (type?: string, response?: any) => {
  switch (type) {
    case 'page':
      return response.data.articles.map(
        (article: any): IOption => {
          return {
            firstLetter: 'Articles',
            ...article,
          };
        },
      );
    case 'category':
      return response.data.categories.map(
        (category: any): IOption => {
          return {
            firstLetter: 'Categories',
            ...category,
          };
        },
      );
    default:
      const articles = response.data.articles.map(
        (article: any): IOption => {
          return {
            firstLetter: 'Articles',
            ...article,
          };
        },
      );

      const categories = response.data.categories.map(
        (category: any): IOption => {
          return {
            firstLetter: 'Categories',
            ...category,
          };
        },
      );

      return [...articles, ...categories];
  }
};
